<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()" *ngIf="!currentUrl">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{titulo | nomenclatura | async }}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido" *ngIf="target != 'noticia_mes' && categorias.length > 1">
    <ion-segment
      class="segment-gradient-title"
      [(ngModel)]="categoriaSelecionada"
      (ionSelect)="selecionarCategoria($event)"
      [scrollable]="true"
      mode="ios"
    >
      <ion-segment-button
        *ngFor="let categoria of categorias; let i = index;"
        [value]="categoria"
      >
        <ion-label>{{categoria.categoria}}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <div class="pesquisa">
    <ion-searchbar
      class="custom"
      *ngIf="target != 'noticia_mes'"
      show-cancel-button="never"
      [placeholder]="('Buscar' | translate)"
      [(ngModel)]="pesquisa"
      (ionInput)="onInput()"
      mode="ios"
    ></ion-searchbar>
  </div>

  <div #divNoticias>
    <div *ngIf="categoria.tipo_lista == 'LISTA_IMAGEM_G_RESUMO'">
      <ng-container *ngFor="let noticia of noticias;">
        <app-list-imagem-resumo [config]="noticia"></app-list-imagem-resumo>
      </ng-container>
    </div>

    <div *ngIf="categoria.tipo_lista == 'LISTA_IMAGEM'">
      <ng-container *ngFor="let noticia of noticias;">
        <app-list-imagem [config]="noticia"></app-list-imagem>
      </ng-container>
    </div>

    <div
      class="img-peq"
      *ngIf="categoria.tipo_lista == 'LISTA_IMAGEM_P_RESUMO'"
    >
      <ng-container *ngFor="let noticia of noticias;">
        <app-list-image-peq [config]="noticia"></app-list-image-peq>
      </ng-container>
    </div>

    <div class="img-peq" *ngIf="categoria.tipo_lista === 'LISTA_TITULO_RESUMO'">
      <ng-container *ngFor="let noticia of noticias;">
        <app-list-titulo-resumo [config]="noticia"> </app-list-titulo-resumo>
      </ng-container>
    </div>
  </div>

  <div
    *ngIf="!noticias.length && target != 'noticia_mes'"
    style="text-align: center"
  >
    <sem-registro [text]="'Nenhuma ' + ('noticia' | nomenclatura | async) + ' encontrada'"></sem-registro>
  </div>

  <div *ngIf="target === 'noticia_mes'">
    <ng-container>
      <app-list-image-accordion
        [noticiasAno]="noticiasAno"
        [texto]="texto"
        [dateFilter]="dateFilter"
        (dateChange)="onDateSelected($event)"
      ></app-list-image-accordion>
    </ng-container>
  </div>
</ion-content>
